import { Component, DestroyRef, inject, Input } from '@angular/core';
import { OnboardingService } from '../onboarding.service';
import { LicensePlate, SignupSearchStatusResponse } from '@shared/models';
import { ArivoStepperComponent } from '@shared/components/ui-elements';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AmplitudeEventService } from '@core/services';
import { RegistrationParkingSessionStatusFetched } from '@integrations/amplitude';

@Component({
  selector: 'app-onboarding-second-step',
  templateUrl: './onboarding-second-step.component.html',
  styleUrl: './onboarding-second-step.component.scss',
})
export class OnboardingSecondStepComponent {
  @Input() stepperComponent?: ArivoStepperComponent;

  destroyRef = inject(DestroyRef);
  parkingSessionStatus: SignupSearchStatusResponse | null = null;

  constructor(
    private onboardingService: OnboardingService,
    private amplitudeEventService: AmplitudeEventService,
  ) {
    this.onboardingService.onboardingSessionStatus.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((session) => {
      this.parkingSessionStatus = session;
      this.amplitudeEventService.trackEvent(
        new RegistrationParkingSessionStatusFetched({
          registrationFlowType: 'ppu',
          registrationParkingSessionStatus: this.parkingSessionStatus?.signup_search
            ? this.parkingSessionStatus.signup_search
            : 'no_session',
        }),
      );
    });
  }

  get publicProductsPageEnabled(): boolean {
    return this.onboardingService.publicProductsPageEnabled;
  }

  get licensePlate(): LicensePlate | null {
    return this.onboardingService.licensePlate.getValue();
  }

  previous() {
    if (this.stepperComponent) {
      this.stepperComponent.previous();
    }
  }

  next() {
    if (this.stepperComponent) {
      this.stepperComponent.next();
    }
  }
}
